import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { IdentitableButtonEnum } from 'src/app/shared/components/subscription-pages/subscription-tables/desktop/subscription-table-desktop.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-upgrade-account',
  templateUrl: './upgrade-account.component.html'
})
export class UpgradeAccountComponent implements OnDestroy {
  private _subs: Subscription[] = [];

  constructor(
    private _router: Router
  ) { }

  ngOnDestroy() {
    this._subs.forEach(it => it.unsubscribe());
  }

  public onIdentitableButtonClicked(buttonClickedName: string) {
    switch (buttonClickedName) {
      case IdentitableButtonEnum.IdentibasePlusButton:
        this.navigateToIdentibasePlusPage();
        break;
      case IdentitableButtonEnum.IdentialertButton:
        this.navigateToIdentialertPage();
        break;
    }
  }

  private navigateToIdentibasePlusPage() {
    this._router.navigate(['/identibase-plus']);
  }

  private navigateToIdentialertPage() {
    this._router.navigate(['/identialert']);
  }
}
